// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__SKcgB","content":"styles_content__1l_Wb","row":"styles_row__3JZuD","footer":"styles_footer__Op-ym","phraseLength":"styles_phraseLength__3AA3u"};